'use strict'

export default class HasDropDown {
  constructor (holder, options) {
    const DEFAULT_OPTIONS = {
      items: 'li',
      drop: 'ul',
      link: 'a',
      dropClass: 'has-drop-down',
      linkClass: 'has-drop-down-a'
    }

    const optionsValid =
      typeof options === 'object' || typeof options === 'undefined'

    this.options = optionsValid
      ? {
          ...DEFAULT_OPTIONS,
          ...options
        }
      : DEFAULT_OPTIONS
    this.holder = holder
    this.items = holder.querySelectorAll(this.options.items)
  }

  init () {
    if (!this.items.length) return

    this.sort()
    this.makeCallBack('onInit', this)
  }

  sort () {
    this.items.forEach((element) => {
      const drop = element.querySelector(this.options.drop)
      const link = element.querySelector(this.options.link)

      if (drop) {
        element.classList.add(this.options.dropClass)

        if (link) link.classList.add(this.options.linkClass)
      }
    })
  }

  makeCallBack (functionName, ...environs) {
    if (typeof this.options[functionName] === 'function') {
      this.options[functionName](environs.length ? environs : this)
    }
  }
}
